import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import { Download } from 'lucide-react';

export default function DownloadApp() {
  const { t } = useLanguage();

  return (
    <section id="get-the-app" className="py-24 sm:py-32 relative overflow-hidden" data-testid="download-section">
      {/* Background matching logo teal/green tones */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#004d40]/[0.03] via-transparent to-[#008751]/[0.05]" />
        <div className="absolute top-1/2 left-0 w-[500px] h-[500px] rounded-full bg-[#00897b]/[0.04] blur-[120px]" />
      </div>

      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* App Screenshots */}
          <div className="flex justify-center order-2 lg:order-1">
            <img
              src="https://customer-assets.emergentagent.com/job_ascifiw3-global/artifacts/9myuh71u_generated-image%20%282%29.png"
              alt="Ascifiw3 Network Community"
              className="w-full max-w-[560px] rounded-3xl object-cover shadow-2xl"
              data-testid="download-app-mockup"
            />
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold mb-6"
              style={{ fontFamily: 'Outfit, sans-serif' }}
              data-testid="download-title"
            >
              {t('downloadApp.title')}
            </h2>
            <p className="text-base lg:text-lg leading-relaxed text-zinc-600 mb-10 max-w-lg">
              {t('downloadApp.subtitle')}
            </p>

            <div className="flex flex-wrap gap-4">
              <a href="https://apps.apple.com/be/app/ascifiw3-network/id6761635343" target="_blank" rel="noopener noreferrer" data-store="ios">
                <Button
                  className="rounded-full bg-[#E31C25] text-white hover:bg-[#c41820] h-14 px-8 text-base font-semibold flex items-center gap-3 transition-transform hover:-translate-y-1 hover:shadow-lg"
                  data-testid="download-ios-btn"
                >
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                  </svg>
                  {t('downloadApp.cta')}
                </Button>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.ascifiw3.network" target="_blank" rel="noopener noreferrer" data-store="android">
                <Button
                  variant="outline"
                  className="rounded-full h-14 px-8 text-base font-semibold border-[#008751]/30 text-[#008751] hover:bg-[#008751]/5 flex items-center gap-3 transition-transform hover:-translate-y-1"
                  data-testid="download-android-btn"
                >
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z" />
                  </svg>
                  {t('downloadApp.ctaAndroid')}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
